"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxonomyClassesContainerv2 = exports.TaxonomyClassesSideBarSection = void 0;
var taxonomy_classes_sidebar_section_component_1 = require("./taxonomy-classes-sidebar-section.component");
Object.defineProperty(exports, "TaxonomyClassesSideBarSection", { enumerable: true, get: function () { return taxonomy_classes_sidebar_section_component_1.TaxonomyClassesSideBarSection; } });
var taxonomy_classes_container_1 = require("./taxonomy-classes.container");
Object.defineProperty(exports, "TaxonomyClassesContainerv2", { enumerable: true, get: function () { return taxonomy_classes_container_1.TaxonomyClassesContainer; } });
